import { Center, Title } from "@mantine/core";

const NotFound = () => {
  return (
    <>
      <Center sx={{ flexGrow: 1 }}>
        <Title>User don't exist</Title>
        
      </Center>
    </>
  );
};

export default NotFound;
